// extracted by mini-css-extract-plugin
module.exports = {"dailyCard":"dailyInfoCard_dailyCard__1Ta_c","event":"dailyInfoCard_event__3QfPG"};